
export function parseSize(str: string | number | 'auto', containerSize: number, contentSize?: number) {
  if (contentSize !== undefined) {
    if (str === 'auto')
      return contentSize;
  }

  if (typeof str === 'number')
    return str;

  str = str.trim();

  if (!str.length)
    return null;

  if (str[str.length - 1] === '%') {
    return (parseFloat(str) / 100.0) * containerSize;
  }
  else {
    return parseFloat(str);
  }
}

export function parseUserDatasetDuration(duration: string) {
  return parseInt(duration.substring(0, duration.length - 1));
}
